export default "__VITE_ASSET__BVdo2HiU__"